export { SignUpViewAdaptive as default } from "../../../navigation/ResponsiveScreens";
